var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNousConnaitre4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d62babf7-7070-4237-94b1-0860bcad8992",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160.19 211.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-6570664c-d2c8-4b69-857d-e685377a9308"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.19,
    y: -4.75,
    width: 175,
    height: 215.38,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#uuid-6570664c-d2c8-4b69-857d-e685377a9308)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.46,19.05l-5.45,31.88H57.16c-.8,6.91-2.61,18.24-5.45,34,7.97-6.38,18.77-9.56,32.41-9.56,17.18,0,30.66,5.56,40.44,16.67,9.78,11.11,14.68,25.43,14.68,42.96,0,7.08-.78,13.81-2.32,20.19-1.55,6.38-4.05,12.4-7.5,18.06-3.45,5.67-7.73,10.58-12.82,14.74-5.09,4.16-11.47,7.44-19.12,9.83-7.66,2.39-16.18,3.59-25.57,3.59-17.89,0-32.74-4.4-44.56-13.21-11.82-8.81-18.75-21.09-20.79-36.86H45.47c3.9,13.37,12.97,20.05,27.23,20.05,8.94,0,15.76-3.01,20.45-9.03,4.69-6.02,7.04-14.08,7.04-24.17,0-21.34-9.16-32.01-27.49-32.01-7.79,0-13.75,1.53-17.86,4.58s-7.33,7.5-9.63,13.35l-35.06-4.65c4.52-20.54,9.65-54.01,15.41-100.41h108.91Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNousConnaitre4);
export default __webpack_public_path__ + "static/media/nous_connaitre_4.ff549a511055195a5a2388547c76d20c.svg";
export { ForwardRef as ReactComponent };